export default __webpack_public_path__ + "static/media/hero.ec871c0e.png";